import { api } from "@/api";

export type BalanceOperation = "add" | "remove";

interface UpdateUsersBalancePayload {
  userIds: number[];
  operation: BalanceOperation;
  amount: number;
}

export async function updateUsersBalance(
  payload: UpdateUsersBalancePayload
): Promise<{ success: boolean }> {
  await Promise.all(
    payload.userIds.map((userId) =>
      api.client.patch(`/users-new/${userId}/balance`, {
        operation: payload.operation,
        amount: payload.amount,
      })
    )
  );
  return { success: true };
}
